package io.horion.cv.utils

object Validators {

    fun getOperator(num: String): String? {
        return when {
            // Orange : 655–659, 685–689, 690–699
            "^6(5[5-9]|8[5-9]|9[0-9])[0-9]{6}$".toRegex().matches(num) -> "orange"

            // MTN : 650–654, 670–679, 680–684
            "^6(5[0-4]|7[0-9]|8[0-4])[0-9]{6}$".toRegex().matches(num) -> "mtn"

            // Sinon Camtel
            else -> null
        }
    }

}